export const BaseUrl = "https://myomnamoapi.prod.myomnamo.com/Api";
// export const BaseUrl = "https://api.myomnamo.mkisan.com/Api";
// export const NewUpdatedBaseUrl = 'https://api.uat.myomnamo.com/api';   // UAT
// export const NewUpdatedBaseUrl = 'https://api.pre-prod.myomnamo.com/api'; // Pre-prod
export const NewUpdatedBaseUrl = 'https://api.prod.myomnamo.com/api'; // Prod

// export const NewUpdatedBaseUrl = "https://api.myomnamo-inventory.mkisan.com/api";



export const GetPhonePayPaymentLink = 'test-phonepe/get-payment-link';
//Test-- '/test-phonepe/get-payment-link'
//PROD-- '/prod-phonepe/get-payment-link'

export const CheckOrderPaymentStatus = 'test-phonepe/check-payment-status'; // PROD---// prod-phonepe/check-payment-status
//Test-- '/test-phonepe/check-payment-status'
//PROD-- '/prod-phonepe/check-payment-status'

